import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Button, DialogTitle, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';

import { groupsAtom } from '@/interfaces/site';
import { mutateProjectAtom } from '@/interfaces/group';

interface CreateProjectDialogProps {
  onClose: () => void;
}

export default function CreateProjectDialog({ onClose }: CreateProjectDialogProps) {
  const { data: groups } = useAtomValue(groupsAtom);
  const { mutate, isPending, data: isCreateSuccess } = useAtomValue(mutateProjectAtom);

  const [selectedGroup, setSelectedGroup] = useState('');
  const [projectName, setProjectName] = useState('');
  const { t } = useTranslation();

  const projectNameTooLong = projectName.length > 45;
  const projectNameErrorText = projectNameTooLong ? '프로젝트 이름은 45자 이하여야 합니다.' : '';

  useEffect(() => {
    if (!groups) return;
    setSelectedGroup(groups.find((group) => group.isDefault).id);
  }, [groups]);
  useEffect(() => {
    if (isCreateSuccess === undefined) return;
    if (isCreateSuccess) {
      onClose();
    } else {
      window.alert(t('Projects.message.cannotCreate'));
    }
  }, [isCreateSuccess, onClose, t]);

  function onOkClick() {
    mutate({
      groupId: selectedGroup,
      data: { projectName },
    });
  }

  return (
    <Stack gap={2} sx={{ minWidth: 480, p: 3 }}>
      <DialogTitle sx={{ px: 0 }}>{t('Projects.label.createProject')}</DialogTitle>
      <Typography>{t('Projects.label.selectGroup')}</Typography>
      <Select value={selectedGroup} onChange={(e) => setSelectedGroup(e.target.value)}>
        {groups &&
          groups.map((group) => (
            <MenuItem key={group.id} value={group.id}>
              {group.name}
            </MenuItem>
          ))}
      </Select>
      <Typography>{t('Projects.label.projectName')}</Typography>
      <TextField
        error={projectNameTooLong}
        helperText={projectNameErrorText}
        value={projectName}
        onChange={(e) => setProjectName(e.target.value)}
      />

      <Stack direction="row" justifyContent="center" gap={3}>
        <Button variant="contained" onClick={onClose} sx={{ bgcolor: '#CCC', color: 'black' }}>
          {t('Common.label.cancel')}
        </Button>
        <Button
          variant="contained"
          onClick={onOkClick}
          disabled={projectName === '' || projectNameTooLong || isPending}
          sx={{ bgcolor: 'info.main' }}
        >
          {t('Common.label.ok')}
        </Button>
      </Stack>
    </Stack>
  );
}
